import { useDarkMode } from '../App'

export type Item = {
  slug: string
  title: string
  authors?: string[]
  year?: number
  license?: string
  type: 'book'|'paper'
  coverUrl?: string
  fileSize?: string
  fileType?: string
  description?: string
}

export default function Card({ item, onClick }:{ item: Item; onClick: ()=>void }){
  const { isDark } = useDarkMode()
  
  return (
    <button onClick={onClick} className="text-left w-full" aria-label={`Open ${item.title}`}>
      <div className={`rounded-2xl border p-3 transition-all hover:shadow-lg ${
        isDark 
          ? 'border-gray-700 bg-gray-800 hover:border-emerald-500/50 hover:shadow-emerald-500/10' 
          : 'border-gray-200 bg-white hover:border-gray-300'
      }`}>
        <div className={`aspect-[3/4] w-full rounded-xl mb-3 flex items-center justify-center ${
          isDark ? 'bg-gray-700' : 'bg-gray-100'
        }`}>
          {item.coverUrl ? (
            <img src={item.coverUrl} alt="" className="w-full h-full object-cover rounded-xl"/>
          ) : (
            <svg className={`w-12 h-12 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          )}
        </div>
        <div className="mt-3">
          <div className={`font-medium line-clamp-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {item.title}
          </div>
          <div className={`text-xs line-clamp-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            {item.authors?.join(', ')}
          </div>
          <div className={`mt-1 flex items-center gap-2 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            {item.year && <span>{item.year}</span>}
            {item.license && (
              <span className={`rounded px-2 py-0.5 ${
                isDark 
                  ? 'bg-emerald-500/20 text-emerald-400' 
                  : 'bg-gray-100 text-gray-700'
              }`}>
                {item.license}
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  )
}